import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CelebrationJobLocation } from '../models/event.model';

const STORAGE_KEY = 'meu_local';

/**
 * Guarda o local (celebrationJobLocation) que o usuário logado comanda,
 * usado no botão "Iniciar no meu local". Persistido em localStorage.
 */
@Injectable({ providedIn: 'root' })
export class MeuLocalService {
  private readonly meuLocalSubject = new BehaviorSubject<CelebrationJobLocation | null>(this.carregar());
  /** Local atual reativo (para refletir na UI, ex.: menu). */
  readonly meuLocal$ = this.meuLocalSubject.asObservable();

  get meuLocal(): CelebrationJobLocation | null {
    return this.meuLocalSubject.value;
  }

  setMeuLocal(local: CelebrationJobLocation): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(local));
    this.meuLocalSubject.next(local);
  }

  limpar(): void {
    localStorage.removeItem(STORAGE_KEY);
    this.meuLocalSubject.next(null);
  }

  private carregar(): CelebrationJobLocation | null {
    try {
      const bruto = localStorage.getItem(STORAGE_KEY);
      return bruto ? (JSON.parse(bruto) as CelebrationJobLocation) : null;
    } catch {
      return null;
    }
  }
}
